import { AxiosError } from 'axios';
import { left, right } from '../../../../shared/core/Either';
import { Result } from '../../../../shared/core/Result';
import { APIResponse } from '../../../../shared/infra/api/APIResponse';
import { BaseAPI } from '../../../../shared/infra/api/BaseAPI';
import { IAuthService } from '../../../users/services/authService';
import { FeaturedFeedItemsResponse } from '../infra/types';
import { FeaturedFeedItemModel } from '../models/FeaturedFeedItem.model';
import { FeaturedUtil } from '../utils/FeaturedUtils';

export interface IFeaturedFeedItemService {
  getCommunityFeaturedFeedItems(): Promise<
    APIResponse<FeaturedFeedItemModel[]>
  >;
}

export class FeaturedFeedItemService
  extends BaseAPI
  implements IFeaturedFeedItemService {
  protected onFailureExecuteImpl(error: AxiosError<any>): Promise<any> {
    throw new Error(`Method not implemented. ${error.name}`);
  }

  constructor(authService: IAuthService) {
    super(authService);
  }

  hasToken(): boolean {
    return this.authService.isUserAuthenticated();
  }

  public async getCommunityFeaturedFeedItems(): Promise<
    APIResponse<FeaturedFeedItemModel[]>
  > {
    try {
      const response = await this.get<FeaturedFeedItemsResponse>({
        url: '/v1/feedItems/featured',
        requiresToken: true,
      });

      const featured = response.data.featured;
      return right(
        Result.ok<FeaturedFeedItemModel[]>(
          featured.map((item) => FeaturedUtil.mapToViewModel(item)),
        ),
      );
    } catch (err: any) {
      return left(err.response ? err.response.data : 'Connection Failed');
    }
  }
}
